import { Button, Spinner } from "react-bootstrap";
import classes from "./Modal.module.css";
import CircularColor from "./Spinner";

const Modal = () => {
    return   <div className={classes.card}>
        <CircularColor />
    </div>
}

export default Modal;